import React from 'react';
import { Link } from 'react-router-dom';
import {
  ArrowRight,
  Sparkles,
  ShieldCheck,
  Clock,
  Banknote,
  Smartphone,
  CircleDollarSign,
  FileCheck,
  Building2,
  Lock,
} from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
import './about-point-banner.css';
import bannerGirl from '../assets/images/banner.png';

const features = [
  { icon: ShieldCheck, label: 'RBI Licensed' },
  { icon: Smartphone, label: 'Paperless KYC' },
  { icon: Clock, label: '5 Min Approval' },
  { icon: Banknote, label: 'Max ₹1,00,000' },
];

const leftChips = [
  { icon: CircleDollarSign, label: 'Zero Hidden Charges' },
  { icon: FileCheck, label: 'Minimal Documents' },
];

const rightChips = [
  { icon: Building2, label: 'Direct Bank Transfer' },
  { icon: Lock, label: 'Secure Platform' },
];

const SidePanel = ({ side, chips, statNum, statLabel, statVariant }) => (
  <div className={`apc-hero-side apc-hero-side--${side}`} aria-hidden="true">
    <div className="apc-side-panel">
      <div className="apc-side-stack">
        {chips.map(({ icon: Icon, label }, i) => (
          <div
            key={label}
            className="apc-float-chip"
            style={{ animationDelay: `${i * 0.4}s` }}
          >
            <span className="apc-float-chip-icon">
              <Icon size={18} strokeWidth={2.5} />
            </span>
            <span className="apc-float-chip-text">{label}</span>
          </div>
        ))}
        <div className={`apc-stat-pill apc-stat-pill--${statVariant}`}>
          <span className="apc-stat-pill-num">{statNum}</span>
          <span className="apc-stat-pill-label">{statLabel}</span>
        </div>
      </div>
    </div>
  </div>
);

const AboutPointBanner = () => {
  return (
    <section className="apc-section" aria-label="Apply for loan today">
      <div className="apc-bg" aria-hidden="true">
        <div className="apc-bg-blob apc-bg-blob--1" />
        <div className="apc-bg-blob apc-bg-blob--2" />
        <div className="apc-bg-dots" />
      </div>

      <div className="apc-wrap">
        <ScrollReveal className="apc-stage" y={28}>
          <div className="apc-hero">
            <SidePanel
              side="left"
              chips={leftChips}
              statNum="Instant"
              statLabel="Disbursal"
              statVariant="gold"
            />

            <div className="apc-girl-wrap">
              <div className="apc-girl-glow" aria-hidden="true" />
              <img
                src={bannerGirl}
                alt=""
                className="apc-girl"
                loading="lazy"
                aria-hidden="true"
              />
            </div>

            <SidePanel
              side="right"
              chips={rightChips}
              statNum="Clear"
              statLabel="Terms"
              statVariant="cyan"
            />
          </div>

          <div className="apc-card-wrap">
            <div className="apc-card-float">
              <article className="apc-card">
                <div className="apc-card-accent" aria-hidden="true" />
                <div className="apc-card-shine" aria-hidden="true" />

                <div className="apc-card-top">
                  <span className="apc-badge">
                    <Sparkles size={13} aria-hidden />
                    Quick &amp; Easy
                  </span>
                  <h2 className="apc-title">
                    Apply <span>Today</span>
                  </h2>
                  <p className="apc-desc">100% digital · secure &amp; transparent approval</p>
                </div>

                <div className="apc-perks-strip">
                  <ul className="apc-perks">
                    {features.map(({ icon: Icon, label }) => (
                      <li key={label}>
                        <span className="apc-perk-icon" aria-hidden="true">
                          <Icon size={16} strokeWidth={2.2} />
                        </span>
                        <span className="apc-perk-label">{label}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <Link to="/apply-now" className="apc-cta">
                  Apply Now
                  <ArrowRight size={15} strokeWidth={2.5} aria-hidden />
                </Link>
              </article>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default AboutPointBanner;
